/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}


/**
 * @param {string} url
 * @returns {Boolean}
 */
export function checkUrl(rule, url, callback) {
  const reg = /(https?|ftp|http):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
  if (reg.test(url)) {
    callback();
  } else {
    callback(new Error("请输入正确的url地址"));
  }
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str)
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * 金额输入框验证
 * 最大9999999.99，整数位最多7位，小数位最多2位，因为mysql int类型最大值为2147483647，最大值定位999999999，即金额最大为999999999分，9999999.99元
 * @param rule
 * @param value
 * @param callback
 */
export function isNum(rule, value, callback) {
  const age = /^([1-9]\d{0,6}|0)(\.\d{1,2})?$/;
  if (!age.test(value)) {
    callback(new Error('最多保留2位小数的正数，最大为9999999.99'))
  } else {
    callback()
  }
}

/**
 * 百分比输入框验证
 * 限1-2位整数，或者至多含有两位小数的写法
 * @param rule
 * @param value
 * @param callback
 */
export function isPercent(rule, value, callback) {
  const age = /(^[0-9]{1,2}$)|(^[0-9]{1,2}[\.][0-9]{1,2}$)/;
  if (!age.test(value) || value == 0) {
    callback(new Error('最多保留2位小数的正数，最大为99.99'))
  } else {
    callback()
  }
}

/**
 * 百分比输入框验证
 * 限1-2位整数，或者至多含有两位小数的写法
 * @param rule
 * @param value
 * @param callback
 */
export function isPercentAndZero(rule, value, callback) {
  const age = /(^[0-9]{1,2}$)|(^[0-9]{1,2}[\.][0-9]{1,2}$)/;
  if (!age.test(value)) {
    callback(new Error('最多保留2位小数的正数，最大为99.99'))
  } else {
    callback()
  }
}

export function isPositiveNum(rule, value, callback) {
  const age = /^\+?[0-9]\d*$/;
  if (value && (!age.test(value))) {
    callback(new Error('只能输入正整数'))
  } else {
    callback()
  }
}

export function checkSpecificKey(rule, value, callback) {
  const specialKey = "[`~!#$^&*()=|{}':;',\\[\\].<>/?~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
  for (let i = 0; i < value.length; i++) {
    if (specialKey.indexOf(value.substr(i, 1)) !== -1) {
      callback(new Error('不允许输入特殊字符'))
    }
  }
  callback()
}

/**
 * 简单手机的验证（1开头11位数字）
 * @param rule
 * @param value
 * @param callback
 */
export function isSimpleMobilePhone(rule, value, callback) {
  const reg = /^1[0-9]{10}$/;
  if (value && !reg.test(value)) {
    callback(new Error('手机号格式不正确'))
  } else {
    callback()
  }
}

/**
 * // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
 * @param rule
 * @param value
 * @param callback
 */
export function isIdCardNumber(rule, value, callback) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (!reg.test(value)) {
    callback(new Error('身份证号码格式不正确'))
  } else {
    callback()
  }
}

/**
 * // 邮箱验证
 * @param rule
 * @param value
 * @param callback
 */
export function isEmail(rule, value, callback) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!reg.test(value)) {
    callback(new Error('邮箱格式不正确'))
  } else {
    callback()
  }
}


/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validCodeLength(rule, value, callback) {
  if (value.toFixed().length != 6) {
    callback(new Error('短信验证码为六位数字'))
  } else {
    callback()
  }
}

/**
 * // 密码格式验证
 * @param rule
 * @param value
 * @param callback
 */
export function isPassWord(rule, value, callback) {
  const reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,20}$/;
  // (?![0-9]+$)  表示后面不能为纯数字
  // (?![a-z]+$)  表示后面不能为纯小写字母
  // (?![A-Z]+$)  表示后面不能为纯大写字母
  // (?!([^(0-9a-zA-Z)])+$) 表示后面不能为除数字和字母外的纯特殊符号
  // ^ 这个符号单独用表示“开头”，用在中括号的开头，表示“非”；
  // .{6,}  表示至少6位的任意字符
  // $ 表示“结尾”
  if (!reg.test(value)) {
    callback(new Error('密码长度为8-20位 必须包括大小字母、小写字母、特殊符号、数字中的任意两种'))
  } else {
    callback()
  }
}

/**
 * // 项目名称敏感词汇验证
 * @param rule
 * @param value
 * @param callback
 */
export function sensitiveWord(rule, value, callback) {
  const reg = /(外部员工|佣金|保底|工资|薪金|薪资|薪水)/;
  if (reg.test(value)) {
    callback(new Error('项目名称不能包含外部员工、佣金、保底、工资、薪金、薪资、薪水等词汇'))
  } else {
    callback()
  }

  // if (value.indexOf('外部员工') > -1) {
  //   callback(new Error('项目名称不能包含外部员工、佣金、保底等词汇'))
  // } else if (value.indexOf('佣金') > -1) {
  //   callback(new Error('项目名称不能包含外部员工、佣金、保底等词汇'))
  // } else if (value.indexOf('保底') > -1) {
  //   callback(new Error('项目名称不能包含外部员工、佣金、保底等词汇'))
  // } else {
  //   callback()
  // }
}

// Luhn算法验证银行账号格式是否正确
export function validateBankCard(rule, value, callback) {
  // 不验证null
  if(!value) {
    callback()
  } else {
    let cardNoArr = [];
    for (let i = 0; i < value.length; i++) {
      cardNoArr[i] = parseInt(value.charAt(i))
    }
    for (let i = cardNoArr.length - 2; i >= 0; i -= 2) {
      cardNoArr[i] <<= 1;
      cardNoArr[i] = cardNoArr[i] / 10 + cardNoArr[i] % 10
    }
    let sum = 0;
    for (let i = 0; i < cardNoArr.length; i++) {
      sum += parseInt(cardNoArr[i])
    }
    if (sum % 10 !== 0) {
      callback(new Error('请输入格式正确的借记卡卡号！'))
    } else {
      callback()
    }
  }
}

/**
 *一.身份证号码结构:
 公民身份号码是特征组合码，由十七位数字本体码和一位校验码组成。
 排列顺序从左至右依次为:六位数字地址码，八位数字出生日期码，三位数字顺序码和一位数字校验码。
 二.具体介绍:
 （1）.地址码(前六位数）:
 表示编码对象常住户口所在县(市、旗、区)的行政区划代码，按gb/T2260的规定执行。
 （2）.出生日期码（第七位至十四位）:
 表示编码对象出生的年、月、日，按gb/T7408的规定执行，年、月、日代码之间不用分隔符。[
 （3）.顺序码（第十五位至十七位）:
 表示在同一地址码所标识的区域范围内，对同年、同月、同日出生的人编定的顺序号，顺序码的奇数分配给男性，偶数分配给女性。
 （4）.校验码（第十八位数）:
 作为尾号的校验码，是由号码编制单位按统一的公式计算出来的，如果某人的尾号是0－9，都不会出现X，但如果尾号是10，那么就得用X来代替，
 因为如果用10做尾号，那么 此人的身份证就变成了19位。X是罗马数字的10，用X来代替10，可以保证公民的身份证符合国家标准。
 */
export function isCardID(rule, value, callback) {
  let iSum = 0;
  if (!/^\d{17}(\d|x)$/i.test(value)) {
    callback(new Error('你输入的身份证长度或格式错误！'))
  }
  value = value.replace(/x$/i, "a");
  if (aCity[parseInt(value.substr(0, 2))] == null) {
    callback(new Error('你的身份证地区非法！'))
  }
  let sBirthday = value.substr(6, 4) + "-" + Number(value.substr(10, 2)) + "-" + Number(value.substr(12, 2));
  let d = new Date(sBirthday.replace(/-/g, "/"));
  if (sBirthday !== (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) {
    callback(new Error('身份证上的出生日期非法！'))
  }
  for (let i = 17; i >= 0; i--) {
    iSum += (Math.pow(2, i) % 11) * parseInt(value.charAt(17 - i), 11)
  }
  if (iSum % 11 !== 1) {
    callback(new Error('你输入的身份证号非法！'))
  }
  callback()
}

/**
 * // 金额验证
 * @param rule
 * @param value
 * @param callback
 */
export function isMoney(rule, value, callback) {
  const reg = /(^[1-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/;
  // (?![0-9]+$)  表示后面不能为纯数字
  // (?![a-z]+$)  表示后面不能为纯小写字母
  // (?![A-Z]+$)  表示后面不能为纯大写字母
  // (?!([^(0-9a-zA-Z)])+$) 表示后面不能为除数字和字母外的纯特殊符号
  // ^ 这个符号单独用表示“开头”，用在中括号的开头，表示“非”；
  // .{6,}  表示至少6位的任意字符
  // $ 表示“结尾”
  if (!reg.test(value)) {
    callback(new Error('为大于0或者正数，两位小数，其他符号不可输入'))
  } else {
    if(value == '0.0' || value == '0.00'){
      callback(new Error('为大于0或者正数，两位小数，其他符号不可输入'))
    }else{
      callback()
    }
    
  }
}

// 正整数，最大999999999
export function isPositiveInteger(rule, value, callback) {
  const age = /^\+?[0-9]\d*$/;
  if ((value && (!age.test(value))) || value > 999999999) {
    callback(new Error('只能输入正整数，最大999999999'))
  } else {
    callback()
  }
}

/**
 * 全国省份的代码，身份证验证用到
 */
const aCity = {
  11: "北京",
  12: "天津",
  13: "河北",
  14: "山西",
  15: "内蒙古",
  21: "辽宁",
  22: "吉林",
  23: "黑龙江",
  31: "上海",
  32: "江苏",
  33: "浙江",
  34: "安徽",
  35: "福建",
  36: "江西",
  37: "山东",
  41: "河南",
  42: "湖北",
  43: "湖南",
  44: "广东",
  45: "广西",
  46: "海南",
  50: "重庆",
  51: "四川",
  52: "贵州",
  53: "云南",
  54: "西藏",
  61: "陕西",
  62: "甘肃",
  63: "青海",
  64: "宁夏",
  65: "新疆",
  71: "台湾",
  81: "香港",
  82: "澳门",
  91: "国外"
}



// WEBPACK FOOTER //
// ./src/utils/validate.js